import Navbar from '../component/homePage/navbar'
import Hero from '../component/homePage/hero'
import AboutStudio from '../component/homePage/aboutStudio'
import YoutubeIntegration from '../component/homePage/youtubeAuth'
import CTASection from '../component/homePage/ctaSection'
import Footer from '../component/homePage/footer'

function Homepage() {
  return (
    <div>
      <Navbar/>
      <Hero/>
      <AboutStudio/>
      <YoutubeIntegration/>
      <CTASection/>
      <Footer/>
    </div>
  )
}

export default Homepage